<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-document">  AccountManagement</i>
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-row>
                <el-col :span="24">
                    <el-button v-if="group == 'overseamanager.perm_level_high'" size="small" type="warning" icon="el-icon-circle-plus" @click="dialogAddNewAccountManagementVisible = true">ADD NEW</el-button>
                    <el-dialog title="ADD NEW ACCOUNT" :visible.sync="dialogAddNewAccountManagementVisible">
                        <el-form label-position="left" label-width="150px" class="AddNewAccountManagementForm">
                            <el-form-item label="UserName">
                                <el-input v-model="AddNewAccountManagementFormUserName" placeholder="Please Enter UserName"></el-input>
                            </el-form-item>
                            <el-form-item label="Password">
                                <el-input type="password" v-model="AddNewAccountManagementFormPassword" placeholder="Please Enter Password"></el-input>
                            </el-form-item>
                            <el-form-item label="Password Again">
                                <el-input type="password" v-model="AddNewAccountManagementFormPasswordAgain" placeholder="Please Enter Password Again"></el-input>
                            </el-form-item>
                            <el-form-item label="Country">
                                <el-select v-model="AddNewAccountManagementFormCountry" filterable placeholder="please select" style="width:100%">
                                    <el-option
                                    v-for="item in selectcountryoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Email">
                                <el-input type="email" v-model="AddNewAccountManagementFormEmail" placeholder="Please Enter Email"></el-input>
                            </el-form-item>
                            <el-form-item label="Group">
                                <el-select style="width:100%" v-model="AddNewAccountManagementFormGroup" filterable placeholder="please select">
                                    <el-option
                                    v-for="item in selectGroupoptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                                <!-- <el-input v-model="AddNewAccountManagementFormGroup" placeholder="Please Enter Group"></el-input> -->
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogAddNewAccountManagementVisible = false">Cancel</el-button>
                            <el-button type="primary" @click="AddNewAccountManagement">OK</el-button>
                        </div>
                    </el-dialog>
                    <el-table
                        ref="AccountManagementTable"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(0, 0, 0, 0.8)"
                        :data="tableData.slice((currentpage-1)*pagesize,currentpage*pagesize)"
                        border
                        stripe
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange">
                        <!-- <el-table-column
                            type="selection"
                            width="5px">
                        </el-table-column> -->
                        <el-table-column
                            prop="id"
                            label="ID"
                            align="center"
                            v-if="idshow"
                            width="10px">
                        </el-table-column>
                        <el-table-column
                            prop="username"
                            label="UserName"
                            align="center"
                            width="250px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="password"
                            label="Password"
                            v-if="idshow"
                            align="center"
                            width="250px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="countrych"
                            label=Country
                            align="center"
                            width="250px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="email"
                            label=Email
                            align="center"
                            width="250px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                            prop="groups"
                            label=Group
                            align="center"
                            width="350px"
                            :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column 
                            fixed="right"
                            label="Operation"
                            v-if="group == 'overseamanager.perm_level_high'"
                            align="center"
                            width="150px">
                            <template slot-scope="scope">
                                <el-button
                                size="mini"
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)">Delete</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentpage"
                        :page-sizes="[8, 15, 30, 50]"
                        :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="currentTotal"
                        >
                    </el-pagination>
                </el-col>
            </el-row>
        </div>    
    </div>
</template>

<script>
import { GetcountryinfoSelectOption,GetGroupSelectOption,searchAccountManagementData,AddNewAccountManagementData,DeleteAccountManagementData } from '../../api/index';
export default {
    name: 'basetable',
    data() {
        return {
            group:"",
            currentpage: 1,
            pagesize: 8,
            currentTotal: 0,
            tableData: [],
            multipleSelection: [],
            loading: false,
            idshow: false,
            selectGroupoptions: [],
            selectcountryoptions: [],
            dialogAddNewAccountManagementVisible:false,
            AddNewAccountManagementFormUserName: '',
            AddNewAccountManagementFormPassword: '',
            AddNewAccountManagementFormPasswordAgain : '',
            AddNewAccountManagementFormCountry: '',
            AddNewAccountManagementFormEmail: '',
            AddNewAccountManagementFormGroup: '',
        };
    },
    created() {
        this.group = localStorage.getItem("Group");
        let token = this.$store.getters.idToken;
        searchAccountManagementData (token).then(res => {
            console.log(res);
            this.tableData = res.results;
            this.currentTotal = res.results.length;
        }).catch(error => console.log(error));
        GetGroupSelectOption (token).then(res => {
            console.log(res);
            this.selectGroupoptions = res.name;
        }).catch(error => console.log(error));
        GetcountryinfoSelectOption (token).then(res => {
            console.log(res);
            this.selectcountryoptions = res.countrych;
        }).catch(error => console.log(error));
    },
    methods: {
        handleSizeChange(val) {
        this.pagesize = val;
        console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            this.currentpage = val;
            console.log(`当前页: ${val}`);
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection);
        },
        handleDelete(index, row) {
            let token = this.$store.getters.idToken;
            console.log(index, row);
            console.log(row.id);
            this.$confirm('此Operation将永久Delete该文件, 是否继续?', '提示', {
                confirmButtonText: 'OK',
                cancelButtonText: 'cancel',
                type: 'warning'
            }).then(() => {
                DeleteAccountManagementData ({
                    id: row.id
                },token).then(res => {
                    console.log(res);
                    if(res.code == 1) {
                        this.tableData.splice(((this.currentpage-1)*this.pagesize+index), 1);
                        this.currentTotal--;
                        this.$message({
                            type: 'success',
                            message: 'Delete successful'
                        });
                    }else {
                       this.$message({
                            type: 'warning',
                            message: "You don't have permission to delete an account"
                        });   
                    }                    
                }).catch(error => console.log(error));
            }).catch(() => {
                this.$message({
                    type: 'warning',
                    message: 'Sorry, failed to delete'
                });          
            });            
        },
        AddNewAccountManagement() {
            let token = this.$store.getters.idToken;
            const AddNewAccountManagementFormData = {
                username: this.AddNewAccountManagementFormUserName,
                password: this.AddNewAccountManagementFormPassword,
                countrych: this.AddNewAccountManagementFormCountry,
                email: this.AddNewAccountManagementFormEmail,
                groups: this.AddNewAccountManagementFormGroup
            }
            if(this.AddNewAccountManagementFormPassword == this.AddNewAccountManagementFormPasswordAgain) {
                    AddNewAccountManagementData (AddNewAccountManagementFormData,token).then(res => {
                    if (res.code == 1) {
                        console.log(res);
                        console.log(this.tableData);
                        const AddNewItemRes = {
                            username: this.AddNewAccountManagementFormUserName,
                            password: this.AddNewAccountManagementFormPassword,
                            countrych: this.AddNewAccountManagementFormCountry,
                            email: this.AddNewAccountManagementFormEmail,
                            groups: this.AddNewAccountManagementFormGroup
                        };
                        this.tableData.push(AddNewItemRes);
                        this.currentTotal++;
                        this.$message({
                            message: 'Added successfully',
                            type: 'success'
                        });
                        this.AddNewAccountManagementFormUserName = "";
                        this.AddNewAccountManagementFormPassword = "";
                        this.AddNewAccountManagementFormEmail = "";
                        this.AddNewAccountManagementFormCountry = "";
                        this.AddNewAccountManagementFormGroup = "";
                        this.dialogAddNewAccountManagementVisible = false;                    
                    }else {
                        this.$message({
                            type: 'warning',
                            message: "You don't have permission to add"
                        });
                    }
                }).catch(() => {
                    this.$message({
                        type: 'warning',
                        message: 'Sorry, failed to add'
                    });
                });
            }else {
                this.$message({
                    type: 'warning',
                    message: '两次密码输入不一致！！！'
                }); 
                return false;
            }
        }
    }
};
</script>

<style scoped>
    .searchtitle {
        font-family: Arial, Helvetica, sans-serif;
        font-weight: bold;
        font-size: 16px;
        margin-right: 10px;
    }
    .searchbar {
        padding: 20px 0px;
        margin-top:-30px;
    }
    .AddNewAccountManagementForm {
        font-weight: bold;
        font-size: 16px;
    }
</style>
